import React from "react";
import { connect } from "react-redux";
import { List } from "devextreme-react";
import dateFormatInbox from "../../../../../helpers/dateFormatInbox";
import { setNotificationAsReadById, resetHistory } from "./actions";

class UserNotificationList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.listRef = React.createRef();
  }

  componentWillUnmount = () => {
    this.props.dispatch(resetHistory());
  }

  handleClick = (args) => {
    if (!args.itemData.ReadDate) {
      this.props.dispatch(setNotificationAsReadById(args.itemData.id));
    }

    // Acá hay que realizar la navegación a la sección correspondiente.
  }
  render() {
    return (
      <div className="notification-list-container">
        <List
          className="user-notification-list"
          onItemClick={this.handleClick}
          selectedIndex={2}
          noDataText="Sin resultados"
          items={this.props.listaNotificaciones}
          itemComponent={(props) => (
            <div className={`notification-list-item-wrapper ${!props.ReadDate ? "unread" : ""}`} >
              <div className="icon">
                <div className="circle-type-notification">
                  <div className="circle-text-notification">
                    {props.CompanyName ? "EMP" : "PER"}
                  </div>
                </div>
              </div>
              <div className="text">
                <span className="title">
                  {props.Subject}
                  <span className="time-historial-notif">{dateFormatInbox(props.CreationDate)}</span>
                </span>
                <span className="text">{props.Content}</span>
              </div>
            </div>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.global.userData,
  totalRows: state.historialNotificaciones.totalRows,
  listaNotificaciones: state.historialNotificaciones.listaNotificaciones,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserNotificationList);
